import { UrlPathname } from '~/src/common/navigation';

import { Episode } from './Episode';

type SeriesDetails = {
  pathname: string;
};

export function getEpisodeUrl(episode: Episode, seriesDetails: SeriesDetails) {
  const pathname = UrlPathname.create(seriesDetails.pathname);
  return `${pathname.value}${episode.relativePathname()}`;
}
